module.exports = __webpack_public_path__ + "static/favicon-db0230d0edd5d2b45c0caa7d09544687.ico";